import { render, staticRenderFns } from "./OperateDetaRecord.vue?vue&type=template&id=1c8560d8&scoped=true"
import script from "./OperateDetaRecord.vue?vue&type=script&lang=js"
export * from "./OperateDetaRecord.vue?vue&type=script&lang=js"
import style0 from "./OperateDetaRecord.vue?vue&type=style&index=0&id=1c8560d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8560d8",
  null
  
)

export default component.exports